/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcquirePrinterLockDto
 */
export interface AcquirePrinterLockDto {
    /**
     * URL API drukarki, klucz blokady i tokenu
     * @type {string}
     * @memberof AcquirePrinterLockDto
     */
    url: string;
    /**
     * Losowy identyfikator przeglądarki/karty
     * @type {string}
     * @memberof AcquirePrinterLockDto
     */
    clientId: string;
    /**
     * Czas trwania blokady w sekundach (serwer ogranicza maksimum)
     * @type {number}
     * @memberof AcquirePrinterLockDto
     */
    ttlSeconds?: number;
}

/**
 * Check if a given object implements the AcquirePrinterLockDto interface.
 */
export function instanceOfAcquirePrinterLockDto(value: object): value is AcquirePrinterLockDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function AcquirePrinterLockDtoFromJSON(json: any): AcquirePrinterLockDto {
    return AcquirePrinterLockDtoFromJSONTyped(json, false);
}

export function AcquirePrinterLockDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcquirePrinterLockDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'clientId': json['clientId'],
        'ttlSeconds': json['ttlSeconds'] == null ? undefined : json['ttlSeconds'],
    };
}

export function AcquirePrinterLockDtoToJSON(value?: AcquirePrinterLockDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'url': value['url'],
        'clientId': value['clientId'],
        'ttlSeconds': value['ttlSeconds'],
    };
}

